<script>
import BaseIframe from "@/components/BaseIframe.vue";
export default {
  name: "CookiePolicyView",
  components: {
    BaseIframe
  },
}
</script>

<template>
  <Base-iframe
      :src="'/cookiepolicy?_f=true'"
      :use-sandbox="false"
  />
</template>

